import { useParallax } from 'components/parallax/useParallax'
import { breakpoints } from 'styles/mq'
import ImageSrc from './images/image.png'
import MobileImageSrc from './images/mobile-image.png'
import { Image, ImgContainer } from './styled'

export const ParallaxImage = () => {
  const { ref, translateY } = useParallax({ fromTo: ['-30rem', '30rem'] })

  return (
    <ImgContainer ref={ref} style={{ translateY }}>
      <picture>
        <source srcSet={MobileImageSrc} media={breakpoints.parallaxOff} />
        <Image src={ImageSrc} alt="" aria-hidden />
      </picture>
    </ImgContainer>
  )
}
